import React, { useState } from "react";
import PropertyCard from "../common/property-card";
import BuyPropertyCard from "../common/buy-property-card";
import { Col, Row } from "react-bootstrap";
import { useUser } from "../context/UserContext";
import {useBuyWishlist} from "../context/BuyContext"

const WishList = () => {
  const { user } = useUser();
  const {wishlist} =useBuyWishlist();
  const [selectedtab,setSelectedTab]=useState("buy")

  if (!user.isAuthenticated) {
    return <div>Please log in to view your wishlist.</div>;
  }

  const tabChange=(value)=>
  {
    setSelectedTab(value)
  }
  return (
    <div className="wishlist-property">
      <div className="my-account-title d-flex align-items-center gap-3 mb-3 justify-content-center flex-column mb-3">
        <h2 className="mb-0">My Wishlist</h2>
        <div className="buy-rent-tab">
      <span className={`tab-item ${selectedtab==="buy"?"active":""}`} onClick={()=>tabChange("buy")}>Buy</span>
      <span className={`tab-item ${selectedtab==="rent"?"active":""}`} onClick={()=>tabChange("rent")}>Rent</span>
      {/* <span className="tab-item">Sell</span> */}
    </div>
      </div>
   {selectedtab==="rent" ?
   (
      <Row className="row-gap-gutter">
        {user.WishList.length > 0 ? (
          user.WishList.map((property) => (
            <Col lg={4} key={property.id}>
              <PropertyCard
                property={{
                  ...property,
                  gallery: property.gallery.filter(
                    (media) => media.fileType !== "Video"
                  ),
                }}
                flatId={property.flatId}
              />
            </Col>
          ))
        ) : (
          <div>No items in your wishlist.</div>
        )}
      </Row>
   ):(
        <Row className="row-gap-gutter">
        {wishlist.length > 0 ? (
          wishlist.map((property) => (
            <Col lg={4} key={property.id}>
              <BuyPropertyCard
                property={{
                  ...property,
                  gallery: property.gallery.filter(
                    (media) => media.fileType !== "Video"
                  ),
                }}
                flatId={property.id}
              />
            </Col>
          ))
        ) : (
          <div>No items in your wishlist.</div>
        )}
      </Row>
   )
}
    </div>
  );
};

export default WishList;
